export const FILES_LIMIT = 20;
export const MAX_FILE_SIZE = 10485760;
